export default __webpack_public_path__ + "static/media/inner-360-factory-visibility.e45c69a7.svg";